import React from 'react';
import { Card, CardBody, Table, ButtonGroup, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { SettingAction } from 'redux/actions';
import Skeleton from '@mui/material/Skeleton';
import { checkPermissions } from 'hooks';


const EnrichmentSettings = (props) => {

    const [settingData, setSettingdata] = React.useState(null);

    const handleClick = (key, value) => {
        props.saveSetting({ data_key: key, data: value })
    }

    React.useEffect(() => {
        props.getSetting({ data_key: 'ENRICHMENT_SERVICE' })
    }, [])

    React.useEffect(() => {
        (props.settingSaved) && setSettingdata(parseInt(props.settingSaved.data.data))
    }, [props.settingSaved]);

    React.useEffect(() => {
        (props.settingData) && setSettingdata(parseInt(props.settingData.data))
    }, [props.settingData]);

    const generateRow = (data) => {
        return (
            (data.length > 0) ?
                data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.label}</td>
                        <td style={{ width: 200 }}>
                            <ButtonGroup>
                                {(props.isLoading) ?
                                    <>
                                        <Skeleton variant="rectangular" width={50} height={38} style={{ border: '1px #00aee4 solid', borderTopLeftRadius: 5, borderBottomLeftRadius: 5 }} />
                                        <Skeleton variant="rectangular" width={50} height={38} style={{ border: '1px #00aee4 solid', borderTopRightRadius: 5, borderBottomRightRadius: 5 }} />
                                    </> :
                                    <>
                                        <Button
                                            outline={(settingData) ? false : true}
                                            color="primary"
                                            onClick={() => handleClick(item.key, 1)}
                                            active={(settingData) ? true : false}
                                            disabled={(settingData) ? true : false}
                                        >
                                            ON
                                        </Button>
                                        <Button
                                            outline={(!settingData) ? false : true}
                                            color="primary"
                                            onClick={() => handleClick(item.key, 0)}
                                            active={(!settingData) ? true : false}
                                            disabled={(!settingData) ? true : false}
                                        >
                                            OFF
                                        </Button>
                                    </>


                                }
                            </ButtonGroup>
                        </td>
                    </tr>)
                ) : ''
        )
    }
    return (
        <Card className="mb-3">
            <CardBody>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Setting</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (checkPermissions(props.loginData, 'change_enrichment_settings')) ? generateRow([{ key: 'ENRICHMENT_SERVICE', label: 'Enrichment Service' }]) : 'You do not have permission to view this content'

                        }
                    </tbody>
                </Table>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = (state) => ({


    settingSaved: (state.setting && state.setting.settingSaved) ? state.setting.settingSaved : null,

    settingData: (state.setting && state.setting.settingData && state.setting.settingData.data) ? state.setting.settingData.data : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getSetting: (payload) => dispatch(SettingAction.getSetting(payload)),
    saveSetting: (payload) => dispatch(SettingAction.saveSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnrichmentSettings);

